/**
 * The only module allowed to read `import.meta.env` (plus *.d.ts and the vite
 * configs). Not importable from Next.js: use `./catalog` and `./environment`.
 */
import { parseAppConfig } from "./parse";

export * from "./catalog";
export * from "./environment";
export * from "./errors";
export type { IAppConfig } from "./parse";
export { parseAppConfig } from "./parse";

// Evaluated once at import. `{ ...}` keeps the type a plain record under
// `strictImportMetaEnv`.
export const config = parseAppConfig({ ...import.meta.env });
